// 
var DouyinPushCardRewardRedirector = xClass("DouyinPushCardRewardRedirector", BaseRedirector)
DouyinPushCardRewardRedirector.prototype.getName = function () {
    var self = this
    return "douyinPushCardReward"
}
DouyinPushCardRewardRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
DouyinPushCardRewardRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    
    console.log("[tt] DouyinPushCardRewardRedirector redirect param", param)
    if (global.mini && mini.getPlatform() === MiniPlatform.tt) {
        let options = mini.getLaunchOptionsSync()
        console.log("[tt] DouyinPushCardRewardRedirector redirect start check options", options)
        
        if ((options.scene == "023040" || options.scene == "103040") && param.tt_start_page == "reward"){
            let cardId = param.tt_card_id
            console.log("[tt] DouyinPushCardRewardRedirector cardId=" + cardId)

            let doFetch = function(){
                console.log("[tt] DouyinPushCardRewardRedirector doFetch")
                let http = DouyinRecommendCardRewardFetchHttp.new()
                http.addEventListener(Events.kComplete, (evt)=>{
                    let rewards = evt.data.rewards
                    console.log("[tt] DouyinPushCardRewardRedirector rewards=",rewards)
                    if (rewards && rewards.length > 0){
                        let rewardsList = []
                        for (let i = 1; i < rewards.length; i++) {
                            rewardsList.push(rewards[i])
                            
                        }
                        console.log("[tt] DouyinPushCardRewardRedirector GetRewardsNormalPanel")
                        let GetRewardsNormalPanel = require("clover/panel/GetRewardsNormalPanel")
                        GetRewardsNormalPanel.show({
                            title:"恭喜获得奖励",
                            desc:"击任意位置关闭",
                            add_model: ModuleName.TT_PUSH_CARD,
                            rewardList: rewardsList,
                            closeCb:()=>{
        
                            }
                        })
                    }
                })
                http.addEventListener(Events.kError, (evt) => {
                    Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
                })
                http.addEventListener(Events.kCancel, (evt) => {
                    Toast.make(quickGetErrorText( evt.data, getText("error.tip.load_res_error")))
                })
                http.load(cardId)
            }
            let checkScene = function(){
                let scene = cc.Director.getInstance().getRunningScene()
                if (scene && scene.name == "HomeScene") {
                    doFetch()
                }else{
                    setTimeout(checkScene, 1)
                }
            }
            checkScene()

            return true
        }

    }
    return false
}
module.exports = DouyinPushCardRewardRedirector
